import { render } from "./CreateWorkSheet.vue?vue&type=template&id=98d162ac"
import script from "./CreateWorkSheet.vue?vue&type=script&lang=js"
export * from "./CreateWorkSheet.vue?vue&type=script&lang=js"

import "./CreateWorkSheet.vue?vue&type=style&index=0&id=98d162ac&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/topdog/labs/labWorkSheets/CreateWorkSheet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "98d162ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('98d162ac', __exports__)) {
    console.log('reload')
    api.reload('98d162ac', __exports__)
  }
  
  module.hot.accept("./CreateWorkSheet.vue?vue&type=template&id=98d162ac", () => {
    console.log('re-render')
    api.rerender('98d162ac', render)
  })

}


export default __exports__